import { Trans } from "i18n/Trans";
import React from "react";
import { RecaptchaTextContainer } from "./style";
import { FILES } from "i18n/constants";
import { Body } from "app/_components/components/Text/Body";

const RecaptchaText = (props: { style?: React.CSSProperties }) => (
  <RecaptchaTextContainer {...props}>
    <Body className="text-left text-gray-600" size="xs">
      <Trans
        i18nKey={`${FILES.COMMON}.recaptcha`}
        components={[
          <a
            href="https://policies.google.com/privacy"
            target="_blank"
            rel="noopener noreferrer"
            className="!underline"
          />,
          <a
            href="https://policies.google.com/terms"
            target="_blank"
            rel="noopener noreferrer"
            className="!underline"
          />
        ]}
      />
    </Body>
  </RecaptchaTextContainer>
);

export default RecaptchaText;
